import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiper = new Swiper('#js-carousel .swiper', {
  autoplay: {
    delay: 4000,
  },
  breakpoints: {
    769: {
      centeredSlides: false,
      pagination: {
        el: "#js-carousel .swiper-pagination",
        clickable: true,
      },
      slidesPerView: 4,
    },
  },
  centeredSlides: true,
  loop: true,
  navigation: {
    nextEl: "#js-carousel .swiper-button-next",
    prevEl: "#js-carousel .swiper-button-prev",
  },
  slidesPerView: 1,
  spaceBetween: 0,
});